import { SHOW_SEARCH } from './actionTypes';

const initialState = {
  showSearch:false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SHOW_SEARCH:
      return {
        ...state,
        showSearch: action.payload
      };
    default:
      return state;
  }
}
